export default "__VITE_ASSET__417136cb__"